export default {
  props: {
    heading1: String,
    heading2: String,
    title: String,
    description: String
  }
};